import { MOBILE_HISTORY_INFO_TYPES } from '../mobileHistoryConstants';
import MobileHistoryDateRow from '../MobileHistoryDateRow/MobileHistoryDateRow';
import MobileHistoryPositionRow from '../MobileHistoryPosition/MobileHistoryPositionRow';
import MobileHistoryTransactionRow
    from '../MobileHistoryTransaction/MobileHistoryTransactionRow/MobileHistoryTransactionRow';
import { Virtuoso } from 'react-virtuoso';
import React, { useCallback, useMemo } from 'react';
import {
    IMobileHistoryDateRow,
    IMobileHistoryPositionRow,
    IMobileHistoryRow,
    IMobileHistoryTransactionRow,
} from '../mobileHistory.t';
import _ from 'lodash';
import moment from 'moment';
import { IPosition, ITransaction } from '../../../../modules/Account/types/accountActions.t';
import { MobileHistoryContentVirtuosoRowWrapperStyled } from './styled/MobileHistoryContentStyled';

interface IMobileHistoryContentProps {
    positions?: IPosition[],
    transactions?: ITransaction[],
    useVirtualList?: boolean,
}

function MobileHistoryContent(props: IMobileHistoryContentProps) {
    const { positions, transactions, useVirtualList } = props;

    const historyRowsToRender: IMobileHistoryRow[] = useMemo(() => {
        let currentDate: string;
        const positionRows: IMobileHistoryPositionRow[] = positions?.map(position => ({
            ...position,
            infoType: MOBILE_HISTORY_INFO_TYPES.POSITION,
            infoDate: position.last_update_time || position.open_time,
        })) || [];
        const transactionRows: IMobileHistoryTransactionRow[] = transactions?.map(transaction => ({
            ...transaction,
            infoType: MOBILE_HISTORY_INFO_TYPES.TRANSACTION,
            infoDate: transaction.created_at,
        })) || [];

        return _.sortBy([...positionRows, ...transactionRows], 'infoDate').reverse().reduce((accum, info) => {
            const dateMoment = moment(info.infoDate);
            const day = dateMoment.format('MMMM, D');
            const time = dateMoment.format('HH:mm:ss');
            const historyRow = {
                ...info,
                formattedDate: time,
            };
            if (currentDate !== day) {
                currentDate = day;
                const dataRow: IMobileHistoryDateRow = {
                    infoType: MOBILE_HISTORY_INFO_TYPES.DATE,
                    formattedDate: day,
                };
                return accum.concat(dataRow, historyRow);
            } else {
                return accum.concat(historyRow);
            }
        }, []);
    }, [positions, transactions]);

    const renderRow = useCallback((item: IMobileHistoryRow, index) => {
        switch (item.infoType) {
            case MOBILE_HISTORY_INFO_TYPES.DATE:
                return <MobileHistoryDateRow index={index} key={index} item={item as IMobileHistoryDateRow}/>;
            case MOBILE_HISTORY_INFO_TYPES.POSITION:
                return <MobileHistoryPositionRow key={index} item={item as IMobileHistoryPositionRow}/>;
            default:
                return <MobileHistoryTransactionRow key={index} item={item as IMobileHistoryTransactionRow}/>;
        }
    }, []);

    return <>
        {
            useVirtualList
                ? <Virtuoso
                    increaseViewportBy={400}
                    style={{ height: '100%' }}
                    data={historyRowsToRender}
                    itemContent={(index, item) => <MobileHistoryContentVirtuosoRowWrapperStyled>
                        {renderRow(item, index)}
                    </MobileHistoryContentVirtuosoRowWrapperStyled>}
                    components={{
                        Scroller: MemoizedScroller,
                    }}
                />
                : historyRowsToRender.map(renderRow)
        }
    </>;
}

const Scroller = React.forwardRef<HTMLDivElement>((props, ref) =>
    <div ref={ref} {...props} className={'custom-scrollbar hidden-scrollbar'}/>);
const MemoizedScroller = React.memo(Scroller);

export default MobileHistoryContent;
